//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.PhysicsConstraintBuilder.js";
import "../no/Expression.js";
import "../Mechatronics/Mechatronics.SelectPhysicsConstraint.js";
import "../Mechatronics/Mechatronics.SelectPhysicsJoint.js";
import "../Mechatronics/Mechatronics.SelectAdapterSignal.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"CamProfile",1,"Mechatronics.CamProfile",0],[0,"GraphEndAction",1,0],[1,"InitialTime",0,"Expression",0],[0,"MasterAxisType",1,0],[0,"MasterBaseType",1,0],[1,"MasterOffset",0,"Expression",0],[1,"MasterScaleFactor",0,"Expression",0],[0,"MasterUnit",1,0],[0,"MotionProfile",1,"Mechatronics.MotionProfile",0],[1,"SelectAxisControl",0,"Mechatronics.SelectPhysicsConstraint",0],[1,"SelectMasterJoint",0,"Mechatronics.SelectPhysicsJoint",0],[1,"SelectMasterSignal",0,"Mechatronics.SelectAdapterSignal",0],[1,"SlaveOffset",0,"Expression",0],[1,"SlaveScaleFactor",0,"Expression",0],[0,"SlaveUnit",1,0],[1,"ValueOffset",0,"Expression",0]],[],[]];
SPLM.Mechatronics.GraphControlBuilder = class extends SPLM.Mechatronics.PhysicsConstraintBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.GraphControlBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.GraphControlBuilder.EndAction = Object.freeze({
    "RestartfromBeginning" : "RestartfromBeginning", "DeactivateGraphControl" : "DeactivateGraphControl"});

SPLM.Mechatronics.GraphControlBuilder.MasterValueUnit = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary", "Time" : "Time"});

SPLM.Mechatronics.GraphControlBuilder.SlaveValueUnit = Object.freeze({
    "LinearPosition" : "LinearPosition", "RotaryPosition" : "RotaryPosition", "LinearSpeed" : "LinearSpeed", "RotarySpeed" : "RotarySpeed"});

SPLM.Mechatronics.GraphControlBuilder.MasterJointType = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary"});

SPLM.Mechatronics.GraphControlBuilder.MasterType = Object.freeze({
    "Time" : "Time", "Axis" : "Axis", "Signal" : "Signal"});

export default SPLM;